/**
 * this component resamble the MUI TextField when disabled, but using just Typography will use less width
 @param
  props.label - the label of the textfield
  props.value - the value of the textfield
  props.labelProps - the props of the label
  props.valueProps - the props of the value
 */

import { Typography, TypographyProps } from '@material-ui/core'
import classNames from 'classnames'
import { isEqual } from 'lodash'
import React, { CSSProperties } from 'react'
import { useTranslation } from 'react-i18next'
import { useValueLabelStyles } from './ValueLabel.styles'

export type ValueLabelProps = {
  value: React.ReactText
  label?: React.ReactText | React.ReactNode
  labelProps?: TypographyProps
  valueProps?: TypographyProps
  isLeftAligned?: boolean
  fullWidth?: boolean
  disableMinWidth?: boolean
  onClick?: () => void
  valueLabelRootStyles?: CSSProperties
  labelTranslationKey?: string
  emptyString?: string
}

const ValueLabel = (props: ValueLabelProps) => {
  const classes = useValueLabelStyles(
    props.isLeftAligned ? 'left' : 'right',
    props.fullWidth,
    props.disableMinWidth,
    Boolean(props.onClick)
  )

  const { t } = useTranslation()

  return (
    // <Tooltip
    //   title={props.value?.toString().length > 15 ? props.value : ''}
    //   arrow
    // >
    <div
      className={classes.valueLabelRoot}
      style={props.valueLabelRootStyles}
      onClick={props.onClick}
    >
      {props.label ? (
        <Typography
          variant="caption"
          color="textSecondary"
          {...props.labelProps}
          className={classNames(props.labelProps?.className, classes.label)}
        >
          {props.labelTranslationKey
            ? t(props.labelTranslationKey, props.label.toString())
            : props.label}
        </Typography>
      ) : null}
      <Typography
        variant="body1"
        color="textPrimary"
        title={
          props.value?.toString().length > 15 ? props.value.toString() : ''
        }
        {...props.valueProps}
        className={classNames(classes.value, props.valueProps?.className)}
      >
        {props.value?.toString()?.length > 0 ? props.value : props.emptyString}
      </Typography>
    </div>
    // </Tooltip>
  )
}

export default React.memo(ValueLabel, isEqual)
